(function () {
    'use strict';

    angular
        .module('emails')
        .controller('ManagerController', ManagerController);

    ManagerController.$inject = ['$state', '$stateParams', 'ExpoService', 'CampaignsService', '$uibModal', 'toastr'];


    function ManagerController($state, $stateParams, ExpoService, CampaignsService, $uibModal, toastr) {
        var vm = this;
        vm.datePicker = {
            "autoApply": true
        };

        vm.dateRangeCreationDate = {startDate: null, endDate: null};
        vm.dateRangeDispatchDate = {startDate: null, endDate: null};
        vm.query = [];
        vm.form = [];

        vm.campaignTypeList = [{
            id: -1,
            name: ' '
        }, {
            name: 'Events (Physical and Online)',
            id: 2
        }, {
            name: 'General News',
            id: 3
        }, {
            name: 'School and Partner Promotions',
            id: 1
        }];
        vm.campaignTypeSelected = [];
        vm.campaigns = [];
        vm.campaignTitle = '';
        vm.physicalFairSelected = [];
        vm.physicalFairList = [];
        vm.virtualFairSelected = [];
        vm.virtualFairList = [];
        vm.noResultMessage = '';
        vm.physicalRequired = true;
        vm.virtualRequired = true;

        vm.selectPhysicalFair = selectPhysicalFair;
        vm.selectVirtualFair = selectVirtualFair;
        vm.onChangeFilter = onChangeFilter;
        vm.getByFilter = getByFilter;
        vm.getAllCampaigns = getAllCampaigns;
        vm.viewTemplate = viewTemplate;
        vm.deleteCampaign = deleteCampaign;
        vm.viewReport = viewReport;
        vm.sendEmailTest = sendEmailTest;

        /*PAGINATION*/
        vm.pageChanged = pageChanged;
        vm.setPage = setPage;
        vm.totalItems = [];
        vm.to = [];
        vm.currentPage = null;
        vm.itemsPerPage = [];
        vm.page = 1;

        function activate() {

            vm.getAllCampaigns();
            vm.selectPhysicalFair();
            vm.selectVirtualFair();
        }

        function getByFilter() {
            vm.query.splice('tour_id', 1);
            vm.query = [];
            if (vm.campaignTitle !== '') {
                vm.query['title'] = vm.campaignTitle;
            }
            if (typeof vm.campaignTypeSelected.id !== 'undefined' && vm.campaignTypeSelected.id !== -1) {
                vm.query['adm_email_category_id'] = vm.campaignTypeSelected.id;
            }
            if (typeof vm.physicalFairSelected.id !== 'undefined' && vm.physicalFairSelected.id !== -1) {
                vm.query['tour_type'] = 'physical_fair';
                vm.query['tour_id'] = vm.physicalFairSelected.id;
            }
            if (typeof vm.virtualFairSelected.id !== 'undefined' && vm.virtualFairSelected.id !== -1) {
                vm.query['tour_type'] = 'virtual_fair';
                vm.query['tour_id'] = vm.virtualFairSelected.id;
            }

            if (vm.dateRangeCreationDate.startDate !== null && vm.dateRangeCreationDate.endDate !== null) {
                vm.query['creation_start_date'] = vm.dateRangeCreationDate.startDate.format('YYYY-MM-DD');
                vm.query['creation_end_date'] = vm.dateRangeCreationDate.endDate.format('YYYY-MM-DD');
            }
            if (vm.dateRangeDispatchDate.startDate !== null && vm.dateRangeDispatchDate.endDate !== null) {
                vm.query['dispatch_start_date'] = vm.dateRangeDispatchDate.startDate.format('YYYY-MM-DD');
                vm.query['dispatch_end_date'] = vm.dateRangeDispatchDate.endDate.format('YYYY-MM-DD');
            }
            CampaignsService.getCampaigns(vm.query).then(function (response) {
                vm.campaigns = response.data.data;
                vm.totalItems = response.data.total;
                vm.to = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;

            }).catch(function (err) {});
        }

        function getAllCampaigns() {
            CampaignsService.getAllCampaigns(vm.query).then(function (response) {
                vm.campaigns = response.data.data;
                vm.totalItems = response.data.total;
                vm.to = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
            }).catch(function (err) {});
        }

        function selectPhysicalFair() {
            ExpoService.getExpos().then(function (response) {
                vm.physicalFairList = response.data;
                vm.physicalFairList.unshift({
                    name: " ",
                    id: -1
                });
            }).catch(function (err) {

            });
        }

        function selectVirtualFair() {
            ExpoService.getExposVirtualFair().then(function (response) {
                vm.virtualFairList = response.data;
                vm.virtualFairList.unshift({
                    name: " ",
                    id: -1
                });
            }).catch(function (err) {

            });
        }

        function onChangeFilter(param) {
            if (param == 'physicalFair') {
                vm.virtualRequired = false;
                vm.virtualFairSelected = '';
                vm.physicalRequired = true;
            } else {
                vm.physicalRequired = false;
                vm.physicalFairSelected = '';
                vm.virtualRequired = true;
            }
        }

        function viewTemplate(campaign) {
            $uibModal.open({
                templateUrl: 'templates/emails/campaign/list/viewEmail/template.modal.html',
                controller: 'ViewEmailCampaignController',
                controllerAs: 'ViewEmailCampaign',
                windowClass: 'app-modal-window2',
                resolve: {
                    campaign: function () {
                        return campaign;
                    }
                }
            });
        }

        function deleteCampaign(campaign) {
            $uibModal.open({
                templateUrl: 'templates/emails/campaign/list/deleteEmail/template.modal.html',
                controller: 'deleteEmailCampaignController',
                controllerAs: 'DeleteEmailCampaign',
                resolve: {
                    campaign: function () {
                        return campaign;
                    },
                    campaignsList: function () {
                        return vm.campaigns;
                    }
                }
            });
        }

        function sendEmailTest(campaign) {
            $uibModal.open({
                templateUrl: 'templates/emails/campaign/list/sendEmailTest/template.modal.html',
                controller: 'sendEmailTestController',
                controllerAs: 'SendEmailTest',
                resolve: {
                    campaign: function () {
                        return campaign;
                    },
                    campaignsList: function () {
                        return vm.campaigns;
                    }
                }
            });
        }

        function viewReport(campaign) {
            $uibModal.open({
                templateUrl: 'templates/emails/campaign/list/viewReport/template.modal.html',
                controller: 'ViewReportCampaignController',
                controllerAs: 'ViewReportCampaign',
                windowClass: 'app-modal-window2',
                resolve: {
                    campaign: function () {
                        return campaign;
                    }
                }
            });
        }

        function setPage(pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged(pageNo) {
            vm.page = vm.currentPage;
            vm.query['page'] = parseInt(vm.currentPage);
            if (typeof vm.dateRangeCreationDate.satrtDate !== 'undefined' && vm.dateRangeDispatchDate.satrtDate !== 'undefined') {
                vm.getByFilter();
            } else {
                vm.getAllCampaigns();
            }
        }

        activate();
    }

})();